import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { Circles } from '../../common/loadingComponent';
import { monitoraActions } from '../../../store/monitoraStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from '../../common/noDataComponent';
import Message from '../../common/message';

import './monitora.scss';

class MonitoraDetailPopup extends React.Component {
    static propTypes = {
        articleId: PropTypes.number,
        articleToken: PropTypes.string,
        articleTitle: PropTypes.string,
        entityId: PropTypes.string,
        onLessClicked: PropTypes.func
    };

    static defaultProps = {
        articleId: null,
        articleToken: null,
        articleTitle: null,
        entityId: null,
        onLessClicked: () => null
    };

    render() {
        const detailData = this.props.monitora.details[this.props.articleId];

        if (isNullOrUndefined(detailData))
            return null;

        if (detailData.isLoading)
            return <Circles />;

        if (!isNullOrUndefined(detailData.error)) {
            return (
                <div className="monitora-detail-error">
                    <Message type="error" message={this.props.translate("UnhappyUser.Monitora.Api.Detail")} />
                </div>
            );
        }

        if (isNullOrUndefined(detailData.paragraphs) || detailData.paragraphs.length === 0)
            return <NoDataComponent />;

        return (
            <div className="monitora-detail-content">
                {detailData.paragraphs.map((p, i) => <p key={i}>{ReactHtmlParser(p)}</p>)}
                <span className="link-functional" onClick={() => this.props.onLessClicked()}>
                    <Translate id="Report.Common.Less" />
                </span>
            </div>
        );
    }

    componentDidMount() {
        this.props.getDetail(this.props.articleId, this.props.articleToken, this.props.articleTitle, this.props.entityId);
    }

    componentWillUnmount() {
        this.props.expandDetail(this.props.articleId, false);
    }
}

export default withLocalize(connect(
    state => ({ monitora: state.monitora }),
    dispatch => bindActionCreators(monitoraActions, dispatch)
)(MonitoraDetailPopup));